import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon23: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#73C177"
        d="M7.5 0a7.66 7.66 0 0 1 3.185.686.5.5 0 0 1-.416.91A6.648 6.648 0 0 0 7.5 1C3.907 1 1 3.816 1 7.282c0 2.021.827 3.625 2.685 5.874a444.82 444.82 0 0 1 .759.906c.305.364.52.626.72.884.526.674.885 1.234 1.122 1.787.205.478.312.943.312 1.408 0 .471.401.859.902.859.502 0 .903-.388.903-.859 0-.441.096-.883.282-1.337.231-.567.592-1.141 1.124-1.829.204-.265.424-.535.733-.904l.385-.459.389-.467c.875-1.063 1.442-1.861 1.88-2.717a.5.5 0 0 1 .89.456c-.478.934-1.081 1.783-1.999 2.897a54.16 54.16 0 0 1-.394.473l-.288.344-.095.114c-.302.361-.515.622-.709.874-.482.624-.8 1.128-.991 1.596a2.534 2.534 0 0 0-.207.959C9.403 19.171 8.547 20 7.5 20c-1.047 0-1.902-.829-1.902-1.859 0-.321-.077-.654-.231-1.014-.197-.46-.514-.954-.991-1.566-.192-.247-.4-.501-.699-.857l-.377-.448-.387-.463C.921 11.38 0 9.595 0 7.282 0 3.257 3.361 0 7.5 0Zm0 5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm8-5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm-8 6a1.501 1.501 0 0 0 0 3 1.5 1.5 0 0 0 0-3Zm8-5a3.5 3.5 0 1 0 .001 7.001A3.5 3.5 0 0 0 15.5 1Zm1.898 1.819a.5.5 0 0 1 .125.696l-2.126 3.056a.5.5 0 0 1-.821 0l-1.177-1.695a.5.5 0 0 1 .821-.571l.767 1.104 1.715-2.465a.5.5 0 0 1 .696-.125Z"
      />
    </Svg>
  )
}
